var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',[_c('h1',{staticClass:"display-1"},[_vm._v("Error page")])]),_c('v-card-text',[_vm._v(" Server Error ")]),_c('v-divider'),_c('v-card-actions',[_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }